module.exports = __webpack_public_path__ + "img/img20.b8878646.jpg";